export class CalibrationStatusData {
    constructor() {
        this.CalibrationProgress = CalibrationProgress.Disabled;
        this.TravelTimeCalibration = false;
        this.LamellaTiltCalibration = false;
        this.IsCurrentPositionKnown = false;
    }
}
export var CalibrationProgress;
(function (CalibrationProgress) {
    CalibrationProgress[CalibrationProgress["Disabled"] = 0] = "Disabled";
    CalibrationProgress[CalibrationProgress["MovementTimeCalibration"] = 1] = "MovementTimeCalibration";
    CalibrationProgress[CalibrationProgress["LamellaTiltCalibration"] = 2] = "LamellaTiltCalibration";
})(CalibrationProgress || (CalibrationProgress = {}));
export class PairedWindSensor {
    constructor() {
        this.IsPaired = false;
        this.SensorSeriallId = "";
    }
}
export var FacadeDetection;
(function (FacadeDetection) {
    FacadeDetection[FacadeDetection["Automatic"] = 0] = "Automatic";
    FacadeDetection[FacadeDetection["ForceType90"] = 1] = "ForceType90";
    FacadeDetection[FacadeDetection["ForceType180"] = 2] = "ForceType180";
})(FacadeDetection || (FacadeDetection = {}));
//# sourceMappingURL=ZfBidiConfigParams.js.map